import ImageWMSClass, * as ImageWMSModule from './../../node_modules/ol/source/ImageWMS.js';

class ImageWMS extends ImageWMSClass {
    constructor(options = {}) {
        options = options || {}
        super(options);
    }
}

// Copy all named exports as static methods
for (const key in ImageWMSModule) {
    if (key !== "default") {
        ImageWMS[key] = ImageWMSModule[key];
    }
}

export default ImageWMS;

// Re-export ALL named exports from OL
export * from './../../node_modules/ol/source/ImageWMS.js';